import { useCallback } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useScopeParams } from "./useScopeParams";
import { enrollmentTargetService } from "@/services/enrollmentTargetService";
import { ENROLLMENT_TARGETS_DATASET_TYPE } from "@/views/TrialEnrollment/enrollmentTargetMapping";
import type { UpsertTargetPayload } from "@/views/TrialEnrollment/enrollmentTarget.types";

export function useEnrollmentTargetMutations() {
  const { id } = useScopeParams();
  const queryClient = useQueryClient();

  const invalidateEnrollmentTargets = useCallback(() => {
    queryClient.invalidateQueries({
      predicate: (query) => {
        const [keyPrefix, , body] = query.queryKey as [string, string, unknown];
        if (
          typeof keyPrefix === "string" &&
          keyPrefix.includes(ENROLLMENT_TARGETS_DATASET_TYPE)
        ) {
          return true;
        }
        return (
          !!body &&
          typeof body === "object" &&
          (body as { dataset_type?: string }).dataset_type ===
            ENROLLMENT_TARGETS_DATASET_TYPE
        );
      },
    });
  }, [queryClient]);

  const upsertMutation = useMutation({
    mutationFn: (payload: UpsertTargetPayload) =>
      enrollmentTargetService.upsertTarget(id, payload),
    onSuccess: invalidateEnrollmentTargets,
  });

  return {
    upsertTarget: upsertMutation.mutateAsync,
    isUpserting: upsertMutation.isPending,
  };
}
